import React, { useState, useEffect, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadUser, logoutUser } from '@store/reducers/auth';
import { toggleSidebarMenu } from '@app/store/reducers/ui';
import { addWindowClass, removeWindowClass, sleep } from '@app/utils/helpers';
import Header from '@app/modules/main/header/Header';
import MenuSidebar from '@app/modules/main/menu-sidebar/MenuSidebar';
import Footer from '@app/modules/main/footer/Footer';
import { PfImage } from '@profabric/react-components';
import { getProfile } from '../../services/auth';

const Main = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.auth.currentUser);
  const menuSidebarCollapsed = useSelector(
    (state: any) => state.ui.menuSidebarCollapsed
  );
  //console.log(menuSidebarCollapsed);
  const screenSize = useSelector((state: any) => state.ui.screenSize);
  const [isAppLoaded, setIsAppLoaded] = useState(false);

  const handleToggleMenuSidebar = () => {
    dispatch(toggleSidebarMenu());
  };

  const fetchProfile = async () => {
    try {
      const response = await getProfile();
      if (response.User) {
        dispatch(loadUser(response.User));
        await sleep(1000);
        setIsAppLoaded(true);
      } else {
        dispatch(logoutUser());
        await sleep(1000);
        setIsAppLoaded(true);
      }
    } catch (error) {
      console.log(error);
      dispatch(logoutUser());
      await sleep(1000);
      setIsAppLoaded(true);
    }
  };

  useEffect(() => {
    removeWindowClass('register-page');
    removeWindowClass('login-page');
    removeWindowClass('hold-transition');
    addWindowClass('sidebar-mini');
    document.body.classList.add('layout-fixed');
    fetchProfile();
    return () => {
      removeWindowClass('sidebar-mini');
    };
  }, []);

  useEffect(() => {
    removeWindowClass('sidebar-closed');
    removeWindowClass('sidebar-collapse');
    removeWindowClass('sidebar-open');
    if (menuSidebarCollapsed && screenSize === 'lg') {
      addWindowClass('sidebar-collapse');
    } else if (menuSidebarCollapsed && screenSize === 'xs') {
      addWindowClass('sidebar-open');
    } else if (!menuSidebarCollapsed && screenSize !== 'lg') {
      addWindowClass('sidebar-closed');
      addWindowClass('sidebar-collapse');
    }
  }, [screenSize, menuSidebarCollapsed]);



  const getAppTemplate = useCallback(() => {
    if (!isAppLoaded) {
      return (
        <div className="preloader flex-column justify-content-center align-items-center">
          <PfImage
            className="animation__shake"
            src="/img/shield_logo.png"
            alt="Slomins Logo"
            height={115}
            width={100}
          />
        </div>
      );
    }
    return (
      <>
        <Header user={user} />
        {user && user.role_id == 1 && <MenuSidebar />}

        <div className={`content-wrapper${user && user.role_id != 1 ? ' ml-0' : ''}`}>
          <section className="content">
            <Outlet />
          </section>
        </div>
        {user && user.role_id == 1 && <Footer />}
        <div
          id="sidebar-overlay"
          role="presentation"
          onClick={handleToggleMenuSidebar}
          onKeyDown={() => { }}
        />
      </>
    );
  }, [isAppLoaded]);

  return <div className="wrapper">{getAppTemplate()}</div>;
};

export default Main;
